import { render, staticRenderFns } from "./PowerUserAllocation.vue?vue&type=template&id=ff6310cc&scoped=true&"
import script from "./PowerUserAllocation.vue?vue&type=script&lang=js&"
export * from "./PowerUserAllocation.vue?vue&type=script&lang=js&"
import style0 from "./PowerUserAllocation.vue?vue&type=style&index=0&id=ff6310cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6310cc",
  null
  
)

export default component.exports